<script src='@/api/baseURL.js'></script>
<template>
  <div class='table-box'>
    <QueryForm
      @QuerySearch='QuerySearch'
      :queryForm='queryForm'
    ></QueryForm>

    <div style='display: none'>
      <input
        @change="(e) => uploadInfo(e, '4')"
        id='speechUpload'
        type='file'
      />
    </div>
    <!--        <label for="speechUpload" class="labelImportBtn">-->
    <!--            <span>导入</span>-->
    <!--        </label>-->
    <!-- <el-button type="primary" class="button" @click="createExcel"
        >导出
    </el-button> -->
    <!--        <el-button type="danger" class="button" @click="mobandaochu"-->
    <!--            >模板导出-->
    <!--        </el-button>-->
    <div
      v-if='timeCountDown > 0 && !djs'
      style='font-family: cursive; font-size: 18px'
    >
      倒计时：<span
      style='
                    font-family: fantasy;
                    margin: 0 5px 0 0;
                    font-size: 20px;
                    color: red;
                '
    >{{ timeCountDown }}</span
    >天
    </div>
    <div style='height: 20px'></div>

    <div style='font-size: 15px'>
      <el-table
        :data='tableData'
        border
        style='width: 100%'
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        @selection-change='handleSelectionChange'
      >
        <el-table-column
          type='index'
          width='70'
          label='序号'
          align='center'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='orderNum'
          label='工单流水号'
          align='center'
          width='220'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='customerName'
          label='客户姓名'
          align='center'
          width='180'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='address'
          label='联系地址'
          align='center'
          width='220'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='customerphone'
          label='联系方式'
          align='center'
          width='150'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='servetypename'
          label='服务类别'
          align='center'
          width='180'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='timeStart'
          label='服务开始时间'
          align='center'
          width='220'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='timeEnd'
          label='服务结束时间'
          align='center'
          width='220'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='realPeriod'
          label='时间工作时间/分钟'
          align='center'
          width='180'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='estimateLevel'
          :formatter='estimateLevelFormat'
          label='客户满意度'
          align='center'
          width='120'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label='操作'
          align='center'
          :show-overflow-tooltip='true'
          fixed='right'
          width='150'
        >
          <template slot-scope='scope'>
            <el-button
              type='text'
              @click="detailsVisit('查看', scope.row)"
            >查看
            </el-button>
            <el-button
              type='text'
              @click="callback(scope.row.id, '回访')"
            >回访
            </el-button>
            <!-- <el-button type="text" @click="chehui(scope.row)"
                >撤回
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style='height: 20px'></div>
    <div>
      <el-pagination
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :page-sizes='[10, 20, 30, 40]'
        :page-size='query.pageSize'
        layout='total, sizes, prev, pager, next, jumper'
        :total='totalCount'
      >
      </el-pagination>
    </div>
    <VisitDialog
      ref='visitDialog'
      @updateList='getDataList'
      v-if='showVisit'
      :show-visit.sync='showVisit'
      :showTitle='showTitle'
      :orderInfo='callbackForm'
    ></VisitDialog>

    <el-dialog
      title='回访'
      :visible.sync='dialogVisible'
      width='65%'
      :before-close='handleClose'
      :close-on-click-modal='false'
    >
      <el-row :gutter='10' class='dialogBtns'>
        <el-button
          :type="display === 0 ? 'primary' : 'info'"
          @click='sendMsg'
        >工单信息
        </el-button>
        <el-button
          v-show='btnActive'
          :type="display === 3 ? 'primary' : 'info'"
          @click='callbackingMag'
        >
          处理中回访信息
        </el-button>
        <el-button
          :type="display === 1 ? 'primary' : 'info'"
          @click='disposeMsg'
        >处理信息
        </el-button>

        <el-button
          v-show='btnActive'
          :type="display === 2 ? 'primary' : 'info'"
          @click='callbackMag'
        >回访信息
        </el-button>
      </el-row>
      <CallbackVisitDialog
        ref='CallbackVisitDialog'
        @updateList='getDataList'
        :orderInfo='callbackForm'
        v-if='display === 0'
      ></CallbackVisitDialog>
      <!-- 处理信息 -->
      <div v-show='display === 1'>
        <div style='height: 12px; margin-top: 30px'></div>
        <el-form label-width='180px' ref='form' :model='callbackForm'>
          <el-form-item label='APP用户反馈语音评价2：'>
            <el-input v-model='callbackForm.evaluate'></el-input>
          </el-form-item>
          <audio
            controls='controls'
            preload='auto'
            class='audioActive'
            :src='callbackForm.estimateRecord'
          ></audio>
          <!-- <el-form-item label="第二次语音评价：">
                  <el-input
                      v-model="callbackForm.thirdEstimateRecord"
                  ></el-input>
              </el-form-item>
              <audio
                  controls="controls"
                  preload="auto"
                  class="audioActive"
                  :src="callbackForm.estimate"
              ></audio> -->
          <el-row>
            <el-col :span='12'>
              <el-form-item label='开始时间：'>
                <el-input
                  v-model='callbackForm.timeStart'
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='结束时间：'>
                <el-input
                  v-model='callbackForm.timeEnd'
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label='服务内容：'>
            <el-input
              disabled
              type='textarea'
              v-model='callbackForm.visitContent'
            ></el-input>
          </el-form-item>
          <el-form-item label='工作图片：'>
            <el-row :gutter='10'>
              <el-col :span='6' class='imgBox'>
                <img
                  v-if='callbackForm.picStart'
                  :src='callbackForm.picStart'
                  alt='工作开始图片'
                />
                <div>工作开始</div>
              </el-col>
              <el-col :span='6' class='imgBox'>
                <img
                  v-if='callbackForm.picFinished'
                  :src='callbackForm.picFinished'
                  alt='工作结束图片'
                />
                <div>工作结束</div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label='工作视频：'>
            <div class='uploadBox'>
              <div class='uploadFlex'>
                <!-- {{gongdanForm.video}} -->
                <video
                  id='myvideo1'
                  :src='callbackForm.videoUrl'
                  style='
                                        height: 200px;
                                        width: 300px;
                                        margin: 0 10px;
                                    '
                  ref='videoId'
                  autoplay='true'
                  controls
                  muted
                ></video>
              </div>
            </div>
          </el-form-item>
          <!-- <el-divider></el-divider>
              <div style="height: 12px; margin-top: 30px; color: #169bd5">
              是否合格
              </div>
              <el-divider></el-divider>
              <el-form-item label="状态：" prop="active">
              <el-radio-group
                  v-model="callbackForm.failure"
                  @change="disqualificationFun"
              >
                  <el-radio label="合格"></el-radio>
                  <el-radio label="不合格"></el-radio>
              </el-radio-group>
              </el-form-item> -->
        </el-form>
      </div>
      <!--  处理中回访信息 -->
      <div v-show='display === 3'>
        <div style='height: 12px; margin-top: 30px; color: #169bd5'>
          处理中回访信息
        </div>
        <el-divider></el-divider>
        <el-form label-width='180px' ref='form' :model='callbackForm'>
          <el-form-item label='服务人员是否准时：'>
            <el-radio-group
              disabled
              v-model='callbackForm.isOnTime'
            >
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label='服务态度是否良好：'>
            <el-radio-group disabled v-model='callbackForm.isGood'>
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label='服务时间是否符合规范：'>
            <el-radio-group
              disabled
              v-model='callbackForm.isStandard'
            >
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label='服务人员着装是否整洁：'>
            <el-radio-group disabled v-model='callbackForm.isTidy'>
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label='服务对象评价：'>
            <el-input
              disabled
              type='textarea'
              v-model='callbackForm.ojectEvaluation'
            ></el-input>
          </el-form-item>
          <audio
            controls='controls'
            preload='auto'
            class='audioActive'
            :src='callbackForm.estimateRecord'
          ></audio>
        </el-form>
      </div>
      <!-- 回访信息 -->
      <div v-show='display === 2'>
        <div style='height: 12px; margin-top: 30px; color: #169bd5'>
          回访信息
        </div>
        <el-divider></el-divider>
        <el-form label-width='180px' ref='form' :model='callbackForm'>
          <el-form-item label='客户名称：'>
            <el-col :span='10'>
              <el-input
                v-model='callbackForm.customerName'
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label='联系方式：'>
            <el-row :gutter='10'>
              <el-col :span='10'>
                <el-input
                  v-model='callbackForm.customerphone'
                ></el-input>
              </el-col>
              <el-col :span='1'>
                <i
                  class='el-icon-phone iconPhone'
                  title='电话'
                  @click='callPhone'
                ></i>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label='是否通过App处理工单：' prop='fromApps'>
            <el-radio-group v-model='callbackForm.fromApps'>
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label='上传图片是否符合规范：'
            prop='rightPic'
          >
            <el-radio-group v-model='callbackForm.rightPic'>
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label='服务时间是否符合规范：'
            prop='rightTime'
          >
            <el-radio-group v-model='callbackForm.rightTime'>
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label='是否上传语音评价：'
            prop='rightEstimateRecord'
          >
            <el-radio-group
              v-model='callbackForm.rightEstimateRecord'
            >
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label='服务对象评价：'>
            <el-input
              type='textarea'
              v-model='callbackForm.estimate'
            ></el-input>
          </el-form-item>
          <el-form-item label='服务企业（组织）评价：'>
            <el-input
              type='textarea'
              v-model='callbackForm.jiamengEstimate'
            ></el-input>
          </el-form-item>
          <el-form-item label='客户满意度：'>
            <el-select
              v-model='callbackForm.estimateLevel'
              placeholder='请选择'
            >
              <el-option
                v-for='item in estimateLevelList'
                :key='item.value'
                :label='item.label'
                :value='item.value'
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='是否上门：'>
            <el-radio-group v-model='callbackForm.visited'>
              <el-radio label='0'>是</el-radio>
              <el-radio label='1'>否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <div class='btn'>
        <div>
          <el-button type='primary' @click='send'>确定</el-button>
          <el-button @click='handleClose' type='info'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request.js'
import QueryForm from '@/component/queryform.vue'
import VisitDialog from './components/visitDialog.vue'
import CallbackVisitDialog from './components/callbackVisitDialog'
import headLine from '../components/headline'
import exportVue from '@/utils/exportVue'

export default {
  components: {
    VisitDialog,
    headLine,
    QueryForm,
    CallbackVisitDialog
  },
  data() {
    return {
      parentId: '',
      djs: false,
      timeCountDown: 0, //倒计时
      isSearchContent: true,
      showVisit: false,
      showTitle: '',
      dataIds: [],
      queryForm: {
        customerName: '',
        customerType: '',
        serveproductName: '',
        servestationName: '',
        servePersonName: '',
        timeStart: '',
        timeEnd: ''
      },
      dataId: 0,
      tableData: [],
      totalCount: 0,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      dialogVisible: false,
      sendActive: true,
      btnActive: true,
      display: 0,
      callbackForm: {},
      estimateLevelList: [
        { value: '0', label: '未评价' },
        { value: '1', label: '没有服务' },
        { value: '2', label: '不满意' },
        { value: '3', label: '服务一般' },
        { value: '4', label: '基本满意' },
        { value: '5', label: '非常满意' }
      ],
      isCome0ptions: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '0',
          label: '否'
        }
      ]
    }
  },
  created() {
    this.$post('/rbac/admin/org/info/OrgTreelist', { isValid: 1 }).then(
      (res) => {
        if (res.code === 200) {
          //当前账号绑定的机构所有下级
          let treeList = []
          let lists = this.chbehavior(
            res.content,
            this.$store.state.info.orgId
          )
          if (!lists.children) {
            treeList.push({
              label: lists.label,
              orgId: lists.orgId
            })
            lists = treeList //带同级本身的数据
          } else {
            treeList.push({
              label: lists.label,
              orgId: lists.orgId,
              children: lists.children
            })
            lists = treeList //带同级本身的数据
          }
          //获取当前选择的机构所有下级id集合
          let childrenIdList = this.getChildrenId(lists)
          this.dataIds = childrenIdList
          this.dataIds.push(this.parentId) //追加父级id
          this.getDataList()
        }
      }
    )
  },
  methods: {
    Reset() {
      this.queryForm = {}
      this.getDataList()
    },
    send() {
      const serverObj = this.$refs.CallbackVisitDialog.serverObj
      const changeContent = this.$refs.CallbackVisitDialog.changeContent

      const data = Object.assign(serverObj, this.callbackForm)
      if (Array.isArray(changeContent)) {
        data.changeContent = changeContent.join(',')
      }
      data.states = '3'
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      request({
        url: '/jjyl/servicePgd/info/Visit',
        method: 'POST',
        data: {
          ...data,
          id: this.dataId
        }
      }).then((res) => {
        if (res.code === 200) {
          loading.close()
          this.$message.success('回访成功')
        } else {
          loading.close()
          this.$message.error('回访失败')
        }
        this.handleClose()
        this.getDataList()
      }).catch((error) => {
        this.handleClose()
        loading.close()
      })
    },
    //回访弹窗打开
    async callback(id, title) {
      this.dataId = id
      await this.getDetails(id, title)
      this.$nextTick(async () => {
        console.log(this.$refs.CallbackVisitDialog)
        this.$refs.CallbackVisitDialog &&
        (await this.$refs.CallbackVisitDialog.getEnsureList())
        // this.$refs.CallbackVisitDialog && (await this.$refs.CallbackVisitDialog.getmessageGetAll())
        this.$refs.CallbackVisitDialog &&
        (await this.$refs.CallbackVisitDialog.getServiceTypeList())
      })
    },
    // 回访弹框关闭
    handleClose() {
      this.display = 0
      this.dialogVisible = false
      this.callbackForm = {}
      if (this.$refs.CallbackVisitDialog) {
        this.$refs.CallbackVisitDialog.changeContent = []
      }
    },
    mobandaochu() {
      this.request2({
        url: '/jjyl/servicePgd/info/Templatedownload',
        method: 'POST',
        data: {
          pageNo: this.query.pageNum,
          pageSize: this.query.pageSize
        },
        responseType: 'blob'
      }).then((resp) => {
        if (resp) {
          const blob = new Blob([resp], {
            type: 'application/vnd.ms-excel'
          })
          const fileName = '模板导出.xls'
          const linkNode = document.createElement('a')
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = 'none'
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success('导出成功')
        }
      })
    },

    async fileChange(event) {
      const file = event.target.files[0]
      const personType = '1'
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let formData = new FormData()
      formData.append('personType', personType)
      formData.append('file', file)
      let result = await this.$http.post(
        '/jjyl/servicePgd/info/ServicePgdExcel',
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById('speechUpload')
      fileEle.value = ''
      if (result.code === 200) {
        this.$message.success(result.message)
        this.getDataList()
      } else {
        this.$message.warning(result.message)
      }
    },
    statesFormat(row, column) {
      if (row.states === 0) {
        return '待派发'
      } else if (row.states === 1) {
        return '待处理'
      } else if (row.states === 2) {
        return '待回访'
      } else if (row.states === 3) {
        return '服务完成'
      } else if (row.states === 4) {
        return '待作废'
      } else if (row.states === 5) {
        return '已作废'
      } else if (row.states === 100) {
        return '移动终端接单'
      }
    },
    estimateLevelFormat(row, column) {
      if (row.estimateLevel === '0') {
        return '未评价'
      }
      if (row.estimateLevel === '1') {
        return '一星'
      } else if (row.estimateLevel === '2') {
        return '二星'
      } else if (row.estimateLevel === '3') {
        return '三星'
      } else if (row.estimateLevel === '4') {
        return '四星'
      } else if (row.estimateLevel === '5') {
        return '五星'
      }
    },
    async detailsVisit(title, row) {
      if (title === '新增') {
        this.showTitle = title
        this.showVisit = true
      } else if (title === '查看') {
        this.showTitle = title
        this.showVisit = true
        await this.getDetails(row.id, '查看')
      }
      // 获取服务类型
      // this.$refs.visitDialog && this.$refs.visitDialog.getProjectList()
      // 获取套餐类型
      // this.$refs.visitDialog && this.$refs.visitDialog.getEnsureList()
    },

    //递归获取当前机构数据
    chbehavior(arr, id) {
      let vm = this
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            vm.parentId = a.parentId //当前绑定机构父级id
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
    getDataList() {
      let params = {
        // dataId:this.$store.state.info.orgId,
        dataIds: this.dataIds,
        customerphone: this.queryForm.customerphone,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        orderNum: this.queryForm.orderNum,
        states: '2',
        type: this.queryForm.customerType,
        customerUserType: this.queryForm.customerUserType,
        customerName: this.queryForm.customerName,
        timeStart: this.queryForm.timeStart,
        timeEnd: this.queryForm.timeEnd,
        position: this.queryForm.position,
        servestationName: this.queryForm.servestationName,
        serveproductName: this.queryForm.serveproductName,
        servePersonName: this.queryForm.servePersonName,
        city: '',
        zone: '',
        street: '',
        shequ: '',
        provinceId: this.queryForm.provinceId,
        cityId: this.queryForm.cityId,
        areaId: this.queryForm.areaId,
        streetId: this.queryForm.streetId,
        communityId: this.queryForm.communityId
      }
      request({
        url: '/jjyl/admin/serviceManagement/info/findServicepgdEffect',
        method: 'POST',
        data: params
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list
            this.totalCount = res.content.count
            // 判断工单批次，出现不同的批次工单隐藏倒计时
            let fval = res.content.list[0].completeTime
            res.content.list.map((val) => {
              if (val.completeTime != fval) {
                this.djs = true
              }
            })
            //倒计时天数
            this.timeCountDown =
              this.getDaysBetween(
                new Date(),
                res.content.list[0].completeTime
              ) + 1
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    getDaysBetween(dateString1, dateString2) {
      var startDate = Date.parse(dateString1)
      var endDate = Date.parse(dateString2)
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000)
      days = Math.ceil(days)
      return days
    },
    getDetails(id, t) {
      //回访状态限制，防止多人点击同个回访
      if (t == '回访') {
        request({
          url: '/jjyl/admin/serviceManagement/info/followVerification',
          method: 'POST',
          data: {
            pgdId: id
          }
        }).then((res) => {
          if (res.code === 200) {
            if (res.message == '已经存在回访人员') {
              this.$message.warning(res.message)
            } else {
              //可以继续回访
              this.dialogVisible = true
              request({
                url: '/jjyl/servicePgd/info/findServicepgdById',
                method: 'POST',
                data: {
                  id: id
                }
              }).then((res) => {
                if (res.code === 200) {
                  if (res.content) {
                    this.callbackForm = res.content
                    this.callbackForm.videoUrl =
                      res.content.videoUrl
                  } else {
                    this.callbackForm = {}
                  }
                }
              })
            }
          }
        })
      } else {
        this.dialogVisible = false
        request({
          url: '/jjyl/servicePgd/info/findServicepgdById',
          method: 'POST',
          data: {
            id: id
          }
        }).then((res) => {
          if (res.code === 200) {
            if (res.content) {
              this.callbackForm = res.content
              this.callbackForm.videoUrl = res.content.videoUrl
            } else {
              this.callbackForm = {}
            }
          }
        })
      }
    },
    QuerySearch() {
      this.getDataList()
    },
    //派发
    sendMsg() {
      this.display = 0
    },
    //处理
    disposeMsg() {
      this.display = 1
    },
    //回访
    callbackMag() {
      this.display = 2
    },
    //回访中
    callbackingMag() {
      this.display = 3
    },
    // 点击撤回
    // chehui(row) {
    //     this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //     }).then(() => {
    //         request({
    //             url: "/jjyl/servicePgd/info/withdraw",
    //             method: "POST",
    //             data: row,
    //         }).then((res) => {
    //             console.log(res)
    //             if (res.code === 200) {
    //                 this.$message.success("撤回成功")
    //             } else {
    //                 this.$message.error("撤回失败")
    //             }
    //             this.getDataList()
    //         })
    //     })
    // },
    handleSelectionChange(val) {
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.getDataList()
    },
    //不合格事件
    disqualificationFun(data) {
      this.btnActive = data !== '不合格'
    },
    //打电话时间
    callPhone() {
      this.$store.dispatch('setPhone', this.callbackForm.customerphone)
      exportVue.$emit('question', true)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang='less' scoped>
.QuerySearchBtn {
  margin-left: 60px;
}

.table-operation {
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: center;

  div {
    flex: 1;
  }
}

.labelImportBtn {
  margin: 0 10px;

  span {
    width: 70px;
    height: 40px;
    text-align: center;
    display: inline-block;
    line-height: 40px;
    font-size: 14px;
    background-color: #409eff;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
  }
}

.dialogBtns {
  display: flex;
  justify-content: center;

  .el-button {
    margin-right: 40px;
  }
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.audioActive {
  margin-left: 180px;
  margin-bottom: 20px;
}

.imgBox {
  height: 200px;
  width: 150px;

  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    margin-bottom: 10px;
    width: 100px;
    height: 100px;
  }

  div {
    width: 70%;
    background-color: #169bd5;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
  }
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}

.iconPhone {
  cursor: pointer;
}
</style>
